import * as React from 'react';

import {Modal} from './modal';

import styles from './two-pane-modal.module.css';

type Props = {
    rightSection: React.ReactNode;
    leftSection: React.ReactNode;
    footerBar?: React.ReactNode;
    rightPaneWidth?: number;
    closeButton?: boolean;
    minWidth?: number;
    maxHeight?: number;
};

export function TwoPaneModal(props: Props) {
    const {rightSection, leftSection, footerBar, rightPaneWidth, ...otherProps} = props;

    return (
        <Modal {...otherProps} minHeight={500}>
            <div className={styles.container}>
                <div
                    style={{width: rightPaneWidth ? `calc(100% - ${rightPaneWidth}px` : '50%'}}
                    className={styles['left-container']}
                >
                    {leftSection}
                </div>
                <div style={{width: rightPaneWidth || '50%'}} className={styles['right-container']}>
                    {rightSection}
                </div>
            </div>
            <div className={styles['footer-container']}>{footerBar}</div>
        </Modal>
    );
}
